<template>
  <div>
    <div class="grid grid-cols-3 gap-4 px-6 pt-4" v-if="media.length > 0">
      <div
        class="flex flex-col gap-1.5 items-center"
        v-for="item in media"
        :key="item.id"
        @click="viewUsingMediaViewer(item)"
      >
        <div v-show="isLoaded(item.url)">
          <MediaPreview
            class="hover:cursor-pointer hover:opacity-80"
            :item="item"
            @loaded="handleImageLoad(item.url)"
          />
        </div>
        <div
          v-show="!isLoaded(item.url)"
          class="grid aspect-square place-items-center rounded-lg bg-gray-300 w-full h-full"
        >
          <LoadingSpinner class="!w-8 !h-8" />
        </div>
        <button
          v-if="canDelete"
          type="button"
          class="text-red-600 hover:text-red-800"
          @click.stop="$emit('delete', item.id)"
        >
          <MinusCircleIcon class="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
    </div>
    <MediaViewer
      :open="openMediaViewer"
      :url="activeItem?.url"
      :mime_type="activeItem?.mime_type"
      @close="closeMediaViewer"
      @next="nextItem"
      @previous="previousItem"
      :multiple="media.length > 1"
    />
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue";
import MediaPreview from "@/Tailwind/Components/MediaPreview.vue";
import MediaViewer from "@/Tailwind/Components/MediaViewer";
import LoadingSpinner from "@/Tailwind/Components/LoadingSpinner.vue";
import { MinusCircleIcon } from "@heroicons/vue/24/outline";

const props = defineProps({
  media: { type: Array, default: () => [] },
  canDelete: { type: Boolean, default: false },
});

const activeItem = ref(null);
const openMediaViewer = ref(false);
const loadedMedia = ref(new Map());

const viewUsingMediaViewer = (item) => {
  activeItem.value = item;
  openMediaViewer.value = true;
};

const closeMediaViewer = () => {
  openMediaViewer.value = false;
};

const nextItem = () => {
  const index = props.media.findIndex(
    (photo) => photo.id === activeItem.value.id
  );

  if (index === props.media.length - 1) {
    activeItem.value = props.media[0];
  } else {
    activeItem.value = props.media[index + 1];
  }
};

const previousItem = () => {
  const index = props.media.findIndex(
    (photo) => photo.id === activeItem.value.id
  );

  if (index === 0) {
    activeItem.value = props.media[props.media.length - 1];
  } else {
    activeItem.value = props.media[index - 1];
  }
};

const isLoaded = (imageUrl) => {
  return loadedMedia.value.get(imageUrl) ?? false;
};

const handleImageLoad = (imageUrl) => {
  loadedMedia.value.set(imageUrl, true);
};
</script>
